import { activeStatusFilter, municipalitiesFilter, provincesFilter } from 'modules/common/constants';

export const clientFilters = [provincesFilter, municipalitiesFilter, activeStatusFilter];
